module.exports = __webpack_public_path__ + "img/arrow-top-right.ed684d1d.svg";